const scheduleServiceModal = {
  title: 'Agendar Servicio',
  scheduleTo: 'Agendar para',
  scheduledDate: 'Fecha de agendamiento',
  schedule: 'Agendar',
  cancel: 'Cancelar',
};

export default scheduleServiceModal;
